export default "__VITE_ASSET__BYtoGuNx__"